$(function() {
  const free_shipping_threshold_eu = 50;
  const shipping_cost_eu = 595;

  const free_shipping_threshold_au = 100;
  const free_shipping_threshold_ca = 100;
  const shipping_cost_au = 900;
  const shipping_cost_ca = 800;

  const free_shipping_threshold_pl = 215;
  const shipping_cost_pl = 1300;

  const eu_markets = ['european-union', 'germany', 'france', 'spain', 'italy'];
  const b2g1_markets = ['gb', 'united-states-2', 'australia', 'canada', 'poland'];

  const collection_url = '/collections/collections';
  const text = window.CW_CART_TEXT || {};

  function t(key, fallback) {
    return text[key] || fallback;
  }

  function isMarket(markets) {
    return markets.includes(window.cw_market_handle);
  }

  function countPads(items) {
    const arr = (window.CW_B2G1_IDS || [])
      .map(Number)
      .filter(n => !Number.isNaN(n));

    const ids = new Set(arr);
    const excludedWords = /(keyboard|keycap|aviator cable)/i;

    const totalItems = (items || []).reduce((n, item) => {
      const title = (item.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;
      return n + Number(item.quantity || 0);
    }, 0);

    if (ids.size === 0) return totalItems;

    const whitelistedCount = (items || []).reduce((n, item) => {
      const title = (item.title || '').toLowerCase();
      if (excludedWords.test(title)) return n;

      const qualifies = ids.has(Number(item.product_id));
      return n + (qualifies ? Number(item.quantity || 0) : 0);
    }, 0);

    return whitelistedCount > 0 ? whitelistedCount : totalItems;
  }

  function resetPromoUi() {
    $('#b2g1-offer-card, #eu-savings-card').remove();

    $('.shipping-progress').hide().removeClass('is-success');
    $('.free-shipping-badge').hide();

    $('.shipping-progress .progress-bar').show();
    $('.shipping-progress .progress-bar-value').css('width', '0%');

    $('.cw-cart-drawer-subtotals .discount-row').hide();
  }

  function renderShippingRows(cart) {
    const market = window.cw_market_handle;
    const cartValue = Number((((cart && cart.items_subtotal_price) || 0) / 100).toFixed(2));

    $('.cw-cart-drawer-subtotals .discount-row').hide();

    if (isMarket(eu_markets)) {
      const cartValueWithShipping = cartValue + (shipping_cost_eu / 100);

      if (cartValueWithShipping < free_shipping_threshold_eu) {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_eu));
      } else {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (market === 'australia') {
      if (cartValue < free_shipping_threshold_au) {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_au));
      } else {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else if (market === 'canada') {
      if (cartValue < free_shipping_threshold_ca) {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_ca));
      } else {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

    } else if (market === 'poland') {
      if (cartValue < free_shipping_threshold_pl) {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
        $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_pl));
      } else {
        $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
      }

      $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();

    } else {
      $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();

      if (market === 'united-states-2') {
        $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
      }
    }
  }

  function renderB2G1Offer(cart) {
    const pads = countPads((cart && cart.items) || []);
    const $progressBlock = $('.shipping-progress').first();

    if (!$progressBlock.length) return;

    $('.shipping-progress').hide();
    $('.free-shipping-badge').hide();

    renderShippingRows(cart);

    $progressBlock.before(`
      <div id="b2g1-offer-card" class="b2g1-offer-card">
        <div class="b2g1-title"></div>

        <div class="b2g1-steps">
          <div class="b2g1-step" data-step="1">
            <span>1</span>
            <small>${t('stepAdded', 'Added')}</small>
          </div>

          <div class="b2g1-line"></div>

          <div class="b2g1-step" data-step="2">
            <span>2</span>
            <small>${t('stepAddSecond', 'Add second')}</small>
          </div>

          <div class="b2g1-line"></div>

          <div class="b2g1-step" data-step="3">
            <span>3</span>
            <small>${t('stepGetOneFree', 'Get one FREE 🎁')}</small>
          </div>
        </div>

        <div class="b2g1-message"></div>
        <a href="${collection_url}" class="b2g1-cta"></a>
      </div>
    `);

    const $card = $('#b2g1-offer-card');
    const $title = $card.find('.b2g1-title');
    const $message = $card.find('.b2g1-message');
    const $cta = $card.find('.b2g1-cta');

    const stepCount = Math.min(pads, 3);

    $card.removeClass('is-complete is-compact-success');
    $card.find('.b2g1-step').removeClass('is-complete');
    $card.find('.b2g1-steps').show();
    $cta.show();

    $card.find('.b2g1-step').each(function() {
      const step = Number($(this).data('step'));
      if (step <= stepCount) {
        $(this).addClass('is-complete');
      }
    });

    if (pads <= 1) {
  $title.html(`🎁 ${t('almostThere', 'Buy 2, Get 1 FREE')}`);
  $message.html(t('onlyAmountMoreFreeShipping', 'Add 2 more mousepads and your cheapest one is FREE.'));
  $cta.text(t('browseMousepads', 'Browse Mousepads →'));

} else if (pads === 2) {
  $title.html(`🎁 ${t('greatChoice', 'You’ve Qualified for Your FREE Mousepad!')}`);
  $message.html(t('unlockedFreeShipping', 'Add one more mousepad to claim your offer.'));
  $cta.text(t('chooseFreeMousepad', 'Choose Your FREE Mousepad →'));

} else {
      $card.addClass('is-complete is-compact-success');

      $card.html(`
        <div class="b2g1-title">
          ${t('successTitle', '🎁 FREE MOUSEPAD UNLOCKED!')}
        </div>

        <div class="b2g1-message">
          ${t('successMessage', 'Your Buy 2, Get 1 FREE discount has been applied.')}
        </div>
      `);
    }
  }

  function renderElements(cart_value, cart) {
    resetPromoUi();

    if (!cart || !cart.items || cart.items.length === 0 || cart.item_count === 0) {
      return;
    }

    if (isMarket(eu_markets) || isMarket(b2g1_markets)) {
      renderB2G1Offer(cart);
    } else {
      $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').show();
    }
  }

  function getCartValue(cart) {
    return parseFloat((cart.items_subtotal_price / 100.0).toFixed(2));
  }

 let refreshTimer = null;
const originalFetch = window.fetch.bind(window);

function refreshCart() {
  clearTimeout(refreshTimer);

  refreshTimer = setTimeout(function() {
    originalFetch('/cart.js', {
      cache: 'no-store'
    })
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Cart request failed: ' + response.status);
        }

        return response.json();
      })
      .then(function(cart) {
        renderElements(getCartValue(cart), cart);
      })
      .catch(function(error) {
        console.warn('Cart drawer refresh failed:', error);
      });
  }, 150);
}

function catchRequest() {
  if (window.CW_CART_FETCH_PATCHED) return;

  window.CW_CART_FETCH_PATCHED = true;

  window.fetch = function() {
    const request = originalFetch.apply(window, arguments);

    const url = arguments[0];
    const urlString =
      typeof url === 'string'
        ? url
        : url && url.url;

    if (
      urlString &&
      (
        urlString.includes('/cart/add') ||
        urlString.includes('/cart/change') ||
        urlString.includes('/cart/update') ||
        urlString.includes('/cart/clear')
      )
    ) {
      request
        .then(function() {
          refreshCart();
        })
        .catch(function() {
          // Leave the original cart request to handle its own error.
        });
    }

    return request;
  };
}

  catchRequest();
  refreshCart();

  document.addEventListener('cart:updated', refreshCart);
  document.addEventListener('ajaxCart:updated', refreshCart);
  document.addEventListener('drawer:open', refreshCart);
  document.addEventListener('cart:open', refreshCart);

  document.addEventListener('click', function(e) {
    if (
      e.target.closest('.ajaxcart__qty') ||
      e.target.closest('[data-update-quantity]') ||
      e.target.closest('[data-remove]') ||
      e.target.closest('.ajaxcart__qty-adjust') ||
      e.target.closest('.js-drawer-open-cart') ||
      e.target.closest('[data-cart-trigger]') ||
      e.target.closest('.cart-link') ||
      e.target.closest('[href="/cart"]') ||
      e.target.closest('[name="add"]') ||
      e.target.closest('button[type="submit"]')
    ) {
      refreshCart();
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target.closest('.ajaxcart__qty')) {
      refreshCart();
    }
  });
});